<template>
    <div    class=""
            @keyup="keyPress">
        <!-- This example requires Tailwind CSS v2.0+ -->
        <div class="relative">
            <!--
              Flyout menu, show/hide based on flyout menu state.

              Entering: "transition ease-out duration-200"
                From: "opacity-0 translate-y-1"
                To: "opacity-100 translate-y-0"
              Leaving: "transition ease-in duration-150"
                From: "opacity-100 translate-y-0"
                To: "opacity-0 translate-y-1"
            -->
            <div    class="absolute z-10 left-1/2 transform -translate-x-1/2 mt-3 px-2 w-screen max-w-xs sm:px-0"
                    :class="[navOpen ? 'opacity-100 translate-y-0 transition ease-in duration-150' : 'transition ease-out duration-200 opacity-0 translate-y-1']">
                <div    v-if="navOpen"
                        class="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
                    <div class="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8">
                        <!-- Text Box -->
                        <floating-input     label="Navigate To"
                                            v-model:value="navTarget"
                                            ref="navTargetInput"
                        ></floating-input>

                        <!-- Loop through all of the results -->
                        <a      v-for="match in matches"
                                :href="getNavRoute(match)"
                                class="-m-3 p-3 block rounded-md hover:bg-gray-50 transition ease-in-out duration-150">
                            <p class="text-base font-medium text-gray-900">
                                {{ getNavName(match) }}
                            </p>
                        </a>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import FloatingInput from "@/components/elements/FloatingInput";


/*
 * The reference for what shortcuts exist w/in this navigation.
 * sonicuOnly means it is access independent of a company. (ie. probe calibration, companies, etc)
 * If this is true, then the route needs to be the exact route after the domain name.
 * If SonicuOnly is false then, the route following the company id should be listed.
 */
const NAV_CODES = {
    // Sonicu Only Pages
    'probe calibration': {
        name: 'Probe Calibrations',
        sonicuOnly: true,
        route: '/nova/resources/probe-calibrations',
        shortcuts: ['probe calibration'],
    },
    'companies': {
        name: 'Companies',
        sonicuOnly: true,
        route: '/SonicuTools/Companies',
        shortcuts: ['companies'],
    },
    'global users': {
        name: 'Global Users',
        sonicuOnly: true,
        route: '/sonicu/users',
        shortcuts: ['global users'],
    },
    'enterprise dashboard': {
        name: 'Enterprise Dashboard',
        sonicuOnly: true,
        route: '/enterprise-dashboard',
        shortcuts: ['enterprise dashboard'],
    },
    home: {
        name: 'Home',
        sonicuOnly: true,
        route: '/',
        shortcuts: ['home'],
    },
    nova: {
        name: 'Nova',
        sonicuOnly: true,
        route: '/nova',
        shortcuts: ['nova'],
    },

    // Company Pages
    'settings': {
        name: 'Settings',
        sonicuOnly: false,
        route: 'settings',
        shortcuts: ['settings'],
    },
    'System Settings': {
        name: 'System Settings',
        sonicuOnly: false,
        route: 'settings/system-settings',
        shortcuts: ['system settings'],
    },
    'users': {
        name: 'Local Users',
        sonicuOnly: false,
        route: 'users',
        shortcuts: ['users', 'local users'],
    },
    'device settings': {
        name: 'Device Settings',
        sonicuOnly: false,
        route: 'settings/device-settings',
        shortcuts: ['device settings', 'ds'],
    },
    'device portal': {
        name: 'Device Portal',
        sonicuOnly: false,
        route: 'device-portal',
        shortcuts: ['device portal'],
    },
    'device profile template': {
        name: 'Device Profile Template',
        sonicuOnly: false,
        route: 'device-profile-template',
        shortcuts: ['device profile template'],
    },
    'wizard': {
        name: 'Install Wizard',
        sonicuOnly: false,
        route: 'wizard',
        shortcuts: ['install wizard'],
    },
    'dashboard': {
        name: 'Dashboard',
        sonicuOnly: false,
        route: 'dashboard',
        shortcuts: ['dashboard'],
    },
}

export default {
    name: "DeveloperNavigation",
    mixins: [iconNamesMixin, SonicuCoreMixin],
    components: {FloatingInput},
    props: {
        navOpen: Boolean,
    },
    data() {
        return {
            navTarget: '',
            matches: [],
        }
    },
    created() {
        
    },
    mounted() {
        this.narrowListOfMatches()
    },
    methods: {
        toggleNav() {
            if (this.navOpen) {
                this.closeNav()
            }
            else {
                this.openNav()
            }
        },
        openNav() {
            this.$emit('update:navOpen', true)
            this.focusInput()
        },
        closeNav() {
            // this.focusOut()
            this.reset()
            this.$emit('update:navOpen', false)
        },

        keyPress(event) {
            if (!this.navOpen) {
                return
            }

            // If escape was pressed, exit; if enter is pressed, attempt to navigate
            switch (event.key) {
                case 'Escape':
                    this.closeNav()
                    break

                case 'Enter':
                    this.devNavigate()
                    break

                default:
                    break
            }
        },

        mousePress(event) {

        },
        devNavigate() {
            // If there are any matches navigate to the first one.
            if (this.matches.length > 0) {
                window.location = this.buildUrl(NAV_CODES[this.matches[0]])


                this.closeNav()
                return
            }

            this.closeNav()
        },
        narrowListOfMatches() {
            let navCode = this.navTarget
            if (navCode.length === 0) {
                this.matches = []
                return
            }
            // Lookup the code given
            let matches = []

            Object.keys(NAV_CODES).forEach(code => {
                let codeInfo = NAV_CODES[code]
                if (this.isSonicuOnlyRoute() && !codeInfo.sonicuOnly) {
                    // This is to make sure that while on the sonicu only routes, you don't see normal site options.
                    return
                }

                let codeFound = false
                codeInfo.shortcuts.forEach(item => {
                    if (item.toLowerCase().indexOf(navCode.toLowerCase()) !== -1) {
                        codeFound = true
                    }
                })

                if (codeFound) {
                    matches.push(code)
                }
            })

            this.matches = matches
        },
        getNavRoute(match) {
            if (match in NAV_CODES) {
                return this.buildUrl(NAV_CODES[match])
            }
            return ''
        },
        getNavName(match) {
            if (match in NAV_CODES) {
                return NAV_CODES[match].name
            }
            return ''
        },
        focusInput() {
            this.$nextTick(() => {
                const devNavInput = this.$refs.navTargetInput
                devNavInput.$refs.input.focus();
            })
        },
        focusOut() {
            this.$nextTick(() => {
                const devNavInput = this.$refs.navTargetInput
                devNavInput.$refs.input.blur();
            })
        },
        reset() {
            this.navTarget = ''
            this.matches = []
        },
        buildUrl(navCode) {
            return this.isSonicuOnlyRoute() || navCode.sonicuOnly
                ? navCode.route
                : this.company.buildCompanyRoute(navCode.route)
        },
        isSonicuOnlyRoute() {
            let route = window.location.pathname.split('/')
            let company = route[1]
            return company === 'sonicu' || company === 'SonicuTools' || company === 'enterprise-dashboard'
        }
    },
    computed: {

    },
    watch: {
        navOpen(val) {
            if (val) {
                // If we opened the nav window, refresh matches and focus input
                this.narrowListOfMatches()
                this.focusInput()
            }
            else {
                // if the window is closed, blur the input & reset
                // this.focusOut()
                this.reset()
            }
        },
        navTarget() {
            // Whenever the nav search is changed, update the list
            this.narrowListOfMatches()
        },
    },
}
</script>

<style scoped>

</style>